export type UpgradeProposalType = 'standard' | 'custom';

export interface UpgradeProposalFormData {
	proposalType: UpgradeProposalType;
	// Plan and pricing fields
	websiteUpgrade?: string;
	totalAmountDueToday?: number;
	billingCycle?: string;
	monthsUntilRenewal?: number;
	renewalDate?: string;
	websiteAddon?: string;
	// Custom proposal fields
	prospectName?: string;
	prospectTitle?: string;
	companyName?: string;
	// Add-ons
	fbAdsChecked?: boolean;
	fbPremiumChecked?: boolean;
	gLSAChecked?: boolean;
	customContentChecked?: boolean;
	customContentNonprofitChecked?: boolean;
}

export interface UpgradeProposalGenerationResponse {
	success: boolean;
	fileId?: string;
	pdfUrl?: string;
	fileName?: string;
	error?: string;
}

export const WEBSITE_UPGRADE_OPTIONS = [
	{ value: 'Essential Website', label: 'Essential Website' },
	{ value: 'Preferred Website', label: 'Preferred Website' },
	{ value: 'Prestige Website', label: 'Prestige Website' },
	{ value: 'Ads Only', label: 'Ads Only' },
] as const;

export const BILLING_CYCLE_OPTIONS = [
	{ value: 'Annual', label: 'Annual' },
	{ value: 'Quarterly', label: 'Quarterly' },
	{ value: 'Monthly', label: 'Monthly' },
] as const;

export const WEBSITE_ADDONS = [
	{ value: 'None', label: 'None' },
	{ value: 'FIN Compliance', label: 'FIN Compliance' },
	{ value: 'Translations', label: 'Translations' },
	{ value: 'ADA Compliance', label: 'ADA Compliance' },
] as const;
